<template>
  <p v-for="order in orders">{{order.title}}</p>
</template>

<script setup>
import {useOrdersStore} from "@/stores/orders.js";
import {computed, ref} from "vue";
import {useManagementStore} from "@/stores/management.js";

const managementStore = useManagementStore();
const orderStore = useOrdersStore()

const selectedApplicant = computed(() => managementStore.getSelectedApplicant);
const orders = ref()
async function get_taker_orders(){
  orders.value = await orderStore.action_get_taker_boost_orders({takerID: selectedApplicant.value.id})
}
get_taker_orders()
</script>

<style scoped lang="scss">

</style>